module.exports = __webpack_public_path__ + "static/media/location-icon.0c46d78d.svg";